import CryptoJS from 'crypto-js';

type ReportPayload = Record<string, unknown>;

type CreatePlayerStatisticsReporterOptions<TPayload extends ReportPayload> = {
  trackerPath: string;
  getHashSource: (payload: TPayload) => string;
  postMessageTarget?: Window;
};

type ReportOptions = {
  sendBeacon?: boolean;
  postToParent?: boolean;
};

export const createPlayerStatisticsReporter = <
  TPayload extends ReportPayload,
>({
  trackerPath,
  getHashSource,
  postMessageTarget = window.parent,
}: CreatePlayerStatisticsReporterOptions<TPayload>) => {
  const trackerUrl = `//${document.location.host}${trackerPath}`;

  return {
    report(payload: TPayload, options: ReportOptions = {}) {
      const { sendBeacon = true, postToParent = true } = options;

      if (sendBeacon) {
        const md5Hashed = CryptoJS.MD5(getHashSource(payload)).toString();
        const blobPlayerLog = new Blob([JSON.stringify(payload)], {
          type: 'application/json; charset=UTF-8',
        });
        navigator.sendBeacon(`${trackerUrl}?k=${md5Hashed}`, blobPlayerLog);
      }

      if (postToParent) {
        postMessageTarget.postMessage(payload, '*');
      }
    },
  };
};
